<template>
  <el-dialog
    title="修改结业信息"
    :visible.sync="dialogInfo.show"
    :close-on-click-modal="false"
    @close="handleClose"
    destroy-on-close
    width="600px"
  >
    <el-form
      :model="memberInfo"
      ref="ruleForm"
      :rules="rules"
      label-width="100px"
      class="form"
      size="small"
    >
      <el-form-item label="优秀学员：" prop="isExcellent">
        <el-radio-group v-model="memberInfo.isExcellent">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="结业状态：" prop="graduationStatus">
        <el-select
          class="select-content"
          v-model="memberInfo.graduationStatus"
          placeholder="请选择结业状态"
          @change="graduationStatusChange"
        >
          <el-option
            v-for="(item, i) in graduateTypeList"
            :key="i"
            :label="item.paramValue"
            :value="Number(item.paramKey)"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="培训天数：" prop="days">
        <el-input-number
          v-model="memberInfo.days"
          :step="1"
          :precision="2"
          :min="0"
        />
        <div class="m-t-8">班级学制：{{memberInfo.trainDays}}天；<span v-if="memberInfo.leaveDays !== null">请假时长：{{memberInfo.leaveDays}}天；</span>退学时长：{{memberInfo.dropOutDays}}天；</div>
      </el-form-item>
      <el-form-item
        label="备注："
        prop="graduationRemarks"
        v-if="memberInfo.graduationStatus === 2"
      >
        <el-input
          placeholder="请输入备注"
          v-model="memberInfo.graduationRemarks"
          maxlength="150"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { enrollLeaveDays } from "@/api/classOffline";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          member: {},
        };
      },
    },
    graduateTypeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    nowRow: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      memberInfo: {
        uuid: "",
        isExcellent: null,
        graduationStatus: null,
        days: "",
        graduationRemarks: "",
        leaveDays: null
      },
      rules: {
        isExcellent: [{ required: true, trigger: "blur" }],
        graduationStatus: [{ required: true, message: "请选择结业状态" }],
        days: [{ required: true, message: "请输入培训天数" }],
        graduationRemarks: [{ required: true, message: "请输入备注" }],
      },
      isFirstFetch: true,
    };
  },
  mounted() {
    const {
      uuid,
      isExcellent,
      graduationStatus,
      trainDays: days,
      graduationRemarks,
    } = this.dialogInfo.member;
    this.memberInfo = {
      uuid,
      isExcellent,
      graduationStatus,
      days,
      graduationRemarks,
      leaveDays: null,
      trainDays: null,
      dropOutDays: null
    };
    this.getEnrollLeaveDays();
  },
  methods: {
    graduationStatusChange(val) {
      if (val !== 0) {
        this.getEnrollLeaveDays();
      } else {
        this.memberInfo.days = 0;
      }
    },
    handleClose() {
      this.$emit("close", false);
    },
    // 学员班内请假时长
    getEnrollLeaveDays() {
      enrollLeaveDays({ uuid: this.dialogInfo.member.uuid }).then(({ code, data }) => {
        if (code !== 0) return;
        this.memberInfo.leaveDays = data.leaveDays;
        this.memberInfo.trainDays = data.trainDays;
        this.memberInfo.dropOutDays = data.dropOutDays;
        if (!this.isFirstFetch) {
          this.memberInfo.days = data.surplusDays;
        }
        this.isFirstFetch = false;
      });
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$emit("close", true, this.memberInfo);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}
.m-t-8 {
  margin-top: 8px;
}
</style>